<template lang="pug">
  div
    .text-bold.text-large {{ mensagem.titulo }}
    .text-gray(v-if="mensagem.assunto") {{ mensagem.assunto.descricao }}
    .divider
    div
      span.abbr De:
      span  {{ mensagem.remetente.cpf_cnpj | cpfCnpj }} - {{ mensagem.remetente.razao_social }}
      div
        span.abbr Enviado em:
        small  {{ mensagem.enviado_em | date }}
    .pt-2
      span.abbr Para:
      span  {{ mensagem.destinatario.cpf_cnpj | cpfCnpj }} - {{ mensagem.destinatario.razao_social }}
      div
        span.abbr Lido em:
        small  {{ mensagem.leitura_em | date }}
    .divider
    .text-long(v-html="mensagem.conteudo")
    div(v-if="mensagem.anexos && mensagem.anexos.length")
      .divider
      .columns
        .column.col-auto.my-2.c-hand(v-for="anexo in mensagem.anexos")
          a(:href="anexo.url" target="_blank")
            img.img-responsive.s-rounded(:src="anexo.thumb" style="max-width: 100px")
</template>

<script>
export default {
  props: {
    mensagem: { type: Object, required: true },
  },
}
</script>
